import { TRootState } from "Redux/Reducers";

export const getEventParentCategory = (id: string) => (state: TRootState) => state.eventParentCategory.entries[id];
